import {
  isDesktop
} from './helpers';

const hamburgerWrapper = document.querySelector(".hamburger__wrapper");
const hamburger = document.querySelector(".hamburger");
const body = document.querySelector('body');
const navigationContainer = document.querySelector('.navigation__container');
const headerNavigation = document.querySelector('.header__navigation');


/**
 * Toggle menu on menu-icon click
 */
 if (hamburgerWrapper) {

  hamburgerWrapper.addEventListener("click", function () {
    toggleMenu();
  });
}

/**
 * Toggle mobile menu function
 */
 function toggleMenu() {
    hamburger.classList.toggle("is-active");
    body.classList.toggle('modal-open');
    document.querySelector('span.hamburger-open').style.display = 'none';
    document.querySelector('span.hamburger-close').style.display = 'inline-block';

    body.style.paddingRight = '17px';
    headerNavigation.style.paddingRight = '17px';

    if (body.style.overflow === 'hidden') {
      body.style.overflow = 'initial';
      body.style.paddingRight = '0px';
      headerNavigation.style.paddingRight = '0px';
      document.querySelector('span.hamburger-open').style.display = 'inline-block';
      document.querySelector('span.hamburger-close').style.display = 'none';
    } else {
      body.style.overflow = 'hidden';
    }
    body.classList.toggle('navigation-is-open');
    navigationContainer.classList.toggle('navigation__is-open');
}

/**
 * Fixed navigation
 */
 const fixedNav = document.querySelector('.header__navigation');
 
 function setStickyMenu() {
  let scrollPosition = window.scrollY;
   let offsetA = 80;
   let offsetB = 150;
   
   if (scrollPosition >= offsetA) {
     if (fixedNav) {
       fixedNav.classList.add('sticky');
       body.classList.add('scrolled');
     }
   } else {
    if (fixedNav.classList.contains('sticky')) {
        body.classList.remove('scrolled');
       fixedNav.classList.remove('sticky');
     }
   } 


   if(scrollPosition >= offsetB) {
     fixedNav.classList.add('active');
   } else {
     if (fixedNav.classList.contains('active')) {
      fixedNav.classList.remove('active');
     }
   }
 }
 window.addEventListener('scroll', setStickyMenu);